import { SubscribeQuery } from '.';

export const getById = (id: string): SubscribeQuery => ({
  className: 'Chat',
  where: {
    objectId: id,
  },
});

export const getByChatId = (id: string): SubscribeQuery => ({
  className: 'Chat',
  where: {
    chatId: id,
  },
});

export const getAllRunning = (retailerId: string, currentUserId: string): SubscribeQuery => ({
  className: 'Chat',
  where: {
    retailer: {
      __type: 'Pointer',
      className: 'Retailer',
      objectId: retailerId,
    },
    salesPerson: {
      className: '_User',
      objectId: currentUserId,
      __type: 'Pointer',
    },
    lastMessage: {
      $exists: true,
    },
    customerSupportRequest: {
      $exists: true,
    },
  },
  include: 'lastMessage',
  order: '-lastMessageDate',
  limit: 12,
});

export const getAllFinished = (retailerId: string): SubscribeQuery => ({
  className: 'Chat',
  where: {
    retailer: {
      __type: 'Pointer',
      className: 'Retailer',
      objectId: retailerId,
    },
    customerSupportRequest: {
      $exists: false,
    },
  },
  include: 'lastMessage',
  order: '-lastMessageDate',
  limit: 12,
});

export const getAllWaiting = (retailerId: string): SubscribeQuery => ({
  className: 'Chat',
  where: {
    retailer: {
      __type: 'Pointer',
      className: 'Retailer',
      objectId: retailerId,
    },
    salesPerson: {
      $exists: false,
    },
    customerSupportRequest: {
      $exists: true,
    },
  },
  include: 'lastMessage',
  order: '-lastMessageDate',
  limit: 12,
});

export const getAll = (retailerId: string): SubscribeQuery => ({
  className: 'Chat',
  where: {
    retailer: {
      __type: 'Pointer',
      className: 'Retailer',
      objectId: retailerId,
    },
  },
  include: 'lastMessage',
  order: '-lastMessageDate',
  limit: 12,
});

export const getAllByTeam = (retailerId: string, teamId: string): SubscribeQuery => ({
  className: 'Chat',
  where: {
    retailer: {
      __type: 'Pointer',
      className: 'Retailer',
      objectId: retailerId,
    },
    team: {
      __type: 'Pointer',
      className: 'Team',
      objectId: teamId,
    },
    lastMessage: { $exists: true },
  },
  include: 'lastMessage',
  order: '-lastMessageDate',
  limit: 12,
});

export const getAllByUser = (retailerId: string, userId: string): SubscribeQuery => ({
  className: 'Chat',
  where: {
    retailer: {
      __type: 'Pointer',
      className: 'Retailer',
      objectId: retailerId,
    },
    salesPerson: {
      __type: 'Pointer',
      className: '_User',
      objectId: userId,
    },
    lastMessage: { $exists: true },
    customerSupportRequest: { $exists: true },
  },
  include: 'lastMessage',
  order: '-lastMessageDate',
  limit: 12,
});

const ChatQueries = {
  getAllRunning,
  getAllFinished,
  getAllWaiting,
  getAll,
  getAllByTeam,
  getAllByUser,
  getById,
  getByChatId,
};

export default ChatQueries;
